/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbDispenseGridDto } from './FcbDispenseGridDto';
import {
    FcbDispenseGridDtoFromJSON,
    FcbDispenseGridDtoFromJSONTyped,
    FcbDispenseGridDtoToJSON,
} from './FcbDispenseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbDispenseGridDtoPaginatedResults
 */
export interface FcbDispenseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbDispenseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbDispenseGridDto>}
     * @memberof FcbDispenseGridDtoPaginatedResults
     */
    results?: Array<FcbDispenseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbDispenseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbDispenseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbDispenseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbDispenseGridDtoPaginatedResultsFromJSON(json: any): FcbDispenseGridDtoPaginatedResults {
    return FcbDispenseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbDispenseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbDispenseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbDispenseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbDispenseGridDtoPaginatedResultsToJSON(value?: FcbDispenseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbDispenseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

